/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="client.module.ts" />

module Meevo.Plugins.Client {

    import SalesTypeEnum = Meevo.Model.SalesTypeEnum;

    export enum AccountHistoryItemType {
        Charge = 1,
        Payment = 2, // 30375
        Credit = 3, // 30374
        DepositPayment = 4, //11044921
        DepositCharge = 5  //11039885

    }

    export interface IClientAccountHistory {
        transactionNumber: string;
        locationId: number;
        saleDate: Date;
        amount: number;
        transactionDateTime: Date;
        saleTypeEnum: SalesTypeEnum;
        note: string;
        isRefund: boolean;
        isVoided: boolean;
    }

    export interface IAccountHistoryCriteria {
        Client_TId: string;
        StartDateTime?: Date;
        EndDateTime?: Date;
        ItemType?: AccountHistoryItemType;
        LocationId?: number;
    }

    export interface ITotalAmountBySaleType {
        accountBalance: number;
        allowChargesCreditOnAccount: boolean;
    }

    export interface IAccountHistoryCounts {
        clientAccountHistoryCount: 2,
        totalAmountBySaleTypeList: ITotalAmountBySaleType[];
    }

    export class ClientApiService {

        static factory(): Function {
            let svc = (dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new ClientApiService(dataService);
            };

            svc.$inject = ['meevo.components.common.DataService'];
            return svc;
        }

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService) {
        }

        getAccountHistory(clientId: string, criteria: IAccountHistoryCriteria): ng.IPromise<IClientAccountHistory[]> {
            return this.dataService.getListPaged(`Client/${clientId}/AccountHistory`, {criteria})
        }

        getAccountHistoryCounts(clientId: string, criteria: IAccountHistoryCriteria): ng.IPromise<ITotalAmountBySaleType[]> {
            return this.dataService
                .customMethodData(`api/Client/${clientId}/AccountHistory/Count/`, 'POST', {criteria})
                .then(res => (<IAccountHistoryCounts>res.data).totalAmountBySaleTypeList);
        }

        getAccountHistoryExistingBalance(clientId: string, criteria: IAccountHistoryCriteria): ng.IPromise<ITotalAmountBySaleType> {
            return this.dataService
                .customMethodData(`api/Client/${clientId}/AccountBalance/`, 'POST', {...criteria})
                .then(res => <ITotalAmountBySaleType>res.data);
        }
    }

    angular.module('meevo.plugins.client')
        .service('meevo.plugins.client.ClientApiService', ClientApiService.factory());
}
